<div class="item-direct-select">
  @if (label()) {
    <label class="admin-field-label">{{ label() }}</label>
  }
  <ng-select
    class="admin-ng-select w-100"
    [items]="items()"
    [ngModel]="value"
    (ngModelChange)="onSelect($event)"
    [ngModelOptions]="{standalone: true}"
    [disabled]="disabled"
    [bindLabel]="bindLabel()"
    [compareWith]="compareWith()"
    [placeholder]="value ? '' : placeholder()"
    [notFoundText]="notFoundText()"
    [searchable]="true"
    [clearable]="true"
    appendTo="body"
    [class.is-invalid]="!value && !disabled">
  </ng-select>
</div>
